__turbopack_context__.v({
  "emptyAnimation": "index-module__5nscPW__emptyAnimation",
});
